module.exports = __webpack_public_path__ + "img/years.5fb4220e.png";